import { TextFieldModule } from '@angular/cdk/text-field';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { FormFieldImports, SelectImports } from 'shared/ui-common';

import { FlowchartActionDto, SelectionBehavior } from '@treetop/shared/model';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    TranslocoModule,
    TextFieldModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,
    FormFieldImports,
    SelectImports,
  ],
  selector: 'sidebar-selection-behavior',
  templateUrl: './selection-behavior.component.html',
  styleUrls: ['./selection-behavior.component.scss'],
})
export class SelectionBehaviorComponent {
  @Input() public sidebarElement: FlowchartActionDto;
  @Input() public guidelineComponent;

  @Output() public selectionBehaviourChanged = new EventEmitter<SelectionBehavior>();

  protected onSelectionBehaviorChange(selectionBehavior: SelectionBehavior) {
    this.selectionBehaviourChanged.emit(selectionBehavior);
  }

  protected SelectionBehavior = SelectionBehavior;
}
